<template>
    <div>
        <div
            class="nav nav-tabs"
            role="tablist"
        >
            <Aba
                v-for="(aba, index) in abasBoletinsMedicao" :key="index"
                :aba="aba"
                :abaAtual="codigoAbaAtiva.toLowerCase() === aba.codigo.toLowerCase()"
                :abaAtiva="abaAtiva(aba.abaBoletimMedicaoId)"
                :abaObrigatoria="abaObrigatoria(aba.abaBoletimMedicaoId)"
                :abaVisualizada="abaVisualizada(aba.abaBoletimMedicaoId)"
                :abaEmAjuste="abaEmAjuste(aba.codigo)"
                @abaSelecionada="abaSelecionada"
            />
        </div>
        <div class="tab-content">
            <div v-for="(aba, index) in abasBoletinsMedicao" :key="index">
                <div
                    class="tab-pane fade show"
                    role="tabpanel"
                    v-if="codigoAbaAtiva.toLowerCase() === aba.codigo.toLowerCase()"
                >
                    <template>
                        <div>
                            <slot :name="`conteudo-aba-${aba.codigo.toLowerCase()}`"></slot>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Aba from './AbaComponent.vue';
import BoletimMedicaoServicos from '../BoletimMedicaoServicos.js';
import ContratosServicos from '../../ContratosServicos.js';

export default {
    name: "Abas",
    props: {
        visualizacaoAbasBoletinsMedicao: {
            type: Array,
            required: true
        },
        contratoIdProp: {
            type: String,
        },
        boletimMedicaoIdProp: {
            type: String,
        },
        abasEmAjuste: {
            type: Array,
            default: () => []
        },
        abasComCheckManual: {
            type: Array,
            default: () => []
        },
    },
    components: {
        Aba
    },
    data() {
        return {
            codigoAbaAtiva: 'dados_gerais',
            abasBoletinsMedicao: [],
        };
    },
    computed: {
        visualizacaoAbasBoletinsMedicaoOrdenadas(){
            return this.abasBoletinsMedicao.sort(
                (a, b) => a.ordemApresentacao - b.ordemApresentacao
            )
        },
    },
    methods: {
        obterAbaBoletimMedicaoPorCodigo(codigoAba) {
            return this.abasBoletinsMedicao.find(aba => aba.codigo.toLowerCase() === codigoAba.toLowerCase());
        },
        obterVisualizacaoAbaBoletimMedicaoPorAbaId(abaBoletimMedicaoId) {
            return this.visualizacaoAbasBoletinsMedicao.find(
                v => v.abaBoletimMedicaoId.toLowerCase() === abaBoletimMedicaoId.toLowerCase()
            );
        },
        abaSelecionada(aba) {
            this.codigoAbaAtiva = aba.codigo;
            this.registrarVisualizacaoAba(aba);
            this.$emit('abaSelecionada', aba);
        },
        abaAtiva(abaBoletimMedicaoId) {
            if (this.visualizacaoAbasBoletinsMedicao.length === 0)
                return true;

            const visualizacaoAba = this.obterVisualizacaoAbaBoletimMedicaoPorAbaId(abaBoletimMedicaoId);

            if (visualizacaoAba && visualizacaoAba.configuracaoAbaBoletimMedicao)
                return visualizacaoAba.configuracaoAbaBoletimMedicao.ativo;

            return true;
        },
        abaObrigatoria(abaBoletimMedicaoId) {
            if (this.visualizacaoAbasBoletinsMedicao.length === 0)
                return false;

            const visualizacaoAba = this.obterVisualizacaoAbaBoletimMedicaoPorAbaId(abaBoletimMedicaoId);

            if (visualizacaoAba && visualizacaoAba.configuracaoAbaBoletimMedicao)
                return visualizacaoAba.configuracaoAbaBoletimMedicao.obrigatorio;

            return false;
        },
        abaVisualizada(abaBoletimMedicaoId) {
            if (this.visualizacaoAbasBoletinsMedicao.length === 0)
                return false;

            const visualizacaoAba = this.obterVisualizacaoAbaBoletimMedicaoPorAbaId(abaBoletimMedicaoId);

            if (visualizacaoAba)
                return visualizacaoAba.visualizada;

            return false;
        },
        abaEmAjuste(codigoAba) {
            return (this.abasEmAjuste || [])
                .map(aba => String(aba).toUpperCase())
                .includes(String(codigoAba).toUpperCase());
        },
        registrarVisualizacaoAba(abaBoletimMedicao) {
            const visualizacaoAbaAtual = this.obterVisualizacaoAbaBoletimMedicaoPorAbaId(abaBoletimMedicao.abaBoletimMedicaoId);
            const existeConfiguracaoVisualizacaoAba = visualizacaoAbaAtual !== undefined;

            if ((visualizacaoAbaAtual && visualizacaoAbaAtual.visualizada) || !existeConfiguracaoVisualizacaoAba)
                return; // Já visualizada ou sem configuração definida

            const codigoAba = (abaBoletimMedicao.codigo || '').toUpperCase();
            const requerCheckManual = this.abasComCheckManual
                .map(c => c.toUpperCase())
                .includes(codigoAba);

            if (requerCheckManual) return; // Visualização manual requerida — não registrar automaticamente

            if (this.$store.getters.isFornecedor && abaBoletimMedicao.abaBoletimMedicaoId) {
                BoletimMedicaoServicos.atualizarVisualizacaoFornecedorAbaBoletimMedicao(
                    this.contratoIdProp,
                    this.boletimMedicaoIdProp,
                    abaBoletimMedicao.abaBoletimMedicaoId,
                    true
                )
                .then(response => {
                    if (response.data && response.data.success) {
                        visualizacaoAbaAtual.visualizada = true;
                    }

                    if (!response.success) {
                        if (response.errors && response.errors.length > 0) {
                            this.$toast.error(
                                `${response.errors.join(', ')}`,
                                'Erro ao registrar a visualização da Aba',
                                this.$toastConfig.error
                            )
                        }
                    }
                })
                .catch(error => {
                    this.$toast.error(
                        `${error}`,
                        'Erro',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    // Ação final se necessário
                })
            }
        },
        obterAbasBoletinsMedicao() {
            ContratosServicos.obterAbasBoletinsMedicao()
                .then(response => {
                    if (response.data && response.data.success) {
                        this.abasBoletinsMedicao = response.data.data || [];
                    }

                    if (!response.success) {
                        if (response.errors && response.errors.length > 0) {
                            this.$toast.error(
                                `${response.errors.join(', ')}`,
                                'Erro ao obter as abas do boletim de medição',
                                this.$toastConfig.error
                            )
                        }
                    }
                })
                .catch(error => {
                    this.$toast.error(
                        `${error}`,
                        'Erro',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    // Ação final se necessário
                })
        },
    },
    created() {
        this.obterAbasBoletinsMedicao();
    },
    updated() {
        const abaAtual = this.obterAbaBoletimMedicaoPorCodigo(this.codigoAbaAtiva);

        if (abaAtual && this.boletimMedicaoIdProp)
            this.registrarVisualizacaoAba(abaAtual);
    },
};
</script>
